import { render, staticRenderFns } from "./ReportTypeGroupsList.vue?vue&type=template&id=a78337ce"
import script from "./ReportTypeGroupsList.vue?vue&type=script&lang=js"
export * from "./ReportTypeGroupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports